import { Link, useParams } from "react-router-dom"
import ComparisonPageTemplate from "@/components/templates/ComparisonPageTemplate"
import SeoHead from "@/components/seo/SeoHead"
import { getComparisonBySlug } from "@/data/comparisons"

function ComparisonDetail() {
  const { slug } = useParams()
  const guide = getComparisonBySlug(slug)

  if (!guide) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-teal-50">
        <SeoHead
          title="Comparison Guide Not Found | Vitamin Vital Portal"
          description="This Vitamin Vital Portal comparison guide could not be found. Browse current supplement comparison pages."
          path={`/comparison/${slug || ""}`}
          type="website"
        />
        <div className="max-w-3xl mx-auto px-4 py-24 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Comparison guide not found</h1>
          <p className="text-gray-600 mb-8">
            That comparison is not published yet. See the current Vitamin Vital Portal comparison guides.
          </p>
          <Link
            to="/comparison"
            className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-full font-semibold"
          >
            Back to Comparison Guides
          </Link>
        </div>
      </div>
    )
  }

  return <ComparisonPageTemplate guide={guide} />
}

export default ComparisonDetail
